<template>
  <div class="container">
    <div class="card shadow pt-2 ps-3 pe-3">
      <div class="row">
        <div class="col-md-4 mt-4">
          <div class="form-group">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/inicio">Início</a>
                </li>
                <li class="breadcrumb-item">
                  <a href="/negocio">Negócios</a>
                </li>
                <li class="breadcrumb-item">
                  <a style="color: grey; hover: none"> Cadastrar Negócio </a>
                </li>
              </ol>
              <h3 style="color: #000; margin-left: 15px">Cadastrar Negócio</h3>
            </nav>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <label>Nome</label>
          <input
            type="text"
            class="form-control"
            v-model="state.nome"
            placeholder="Insira o nome do anunciante:"
          />
        </div>
        <div class="col-4">
          <label>Email</label>
          <input
            type="text"
            class="form-control"
            v-model="state.email"
            placeholder="Insira um email:"
          />
        </div>
        <div class="col-4">
          <label>Categoria</label>
          <select class="form-select" v-model="state.categoria_anuncio_id">
            <option
              v-for="grupo in state.grupos"
              :key="grupo.id"
              :value="grupo.id"
            >
              {{ grupo.nome }}
            </option>
          </select>
        </div>
        <div class="col-4">
          <label>Título</label>
          <input
            type="text"
            class="form-control"
            v-model="state.titulo"
            placeholder="Insira um título:"
          />
        </div>
        <div class="col-4">
          <label>Subtítulo</label>
          <input
            type="text"
            class="form-control"
            v-model="state.subtitulo"
            placeholder="Insira um subtítulo:"
          />
        </div>
        <div class="col-4">
          <label>Preço</label>
          <input
            type="text"
            class="form-control"
            v-model="state.preco"
            placeholder="Insira um preço:"
          />
        </div>
        <div class="col-4">
          <label>Telefone</label>
          <input
            type="text"
            class="form-control"
            v-model="state.telefone"
            placeholder="Insira um telefone:"
          />
        </div>
        <div class="col-4">
          <label>Estado</label>
          <select
            class="form-select"
            v-model="state.estado_id"
            @change="fetchCidade($event.target.value)"
          >
            <option
              v-for="estado in state.estados"
              :key="estado.id"
              :value="estado.id"
            >
              {{ estado.nome }}
            </option>
          </select>
        </div>
        <div class="col-4">
          <label>Cidade</label>
          <select class="form-select" v-model="state.cidade_id">
            <option
              v-for="cidade in state.cidades"
              :key="cidade.id"
              :value="cidade.id"
            >
              {{ cidade.nome }}
            </option>
          </select>
        </div>
        <div class="col-4" v-if="state.id != ''">
          <label>Status</label>
          <select class="form-select" v-model="state.status">
            <option value="PENDENTE">Pendente</option>
            <option value="ATIVO">Ativo</option>
            <option value="VENDIDO">Vendido</option>
            <option value="CANCELADO">Cancelado</option>
          </select>
        </div>
        <div class="col-12">
          <label>Descrição</label>
          <textarea v-model="state.descricao" class="form-control"></textarea>
        </div>
        <div class="row">
          <div class="col-4">
            <label>Imagem</label>
            <input
              type="file"
              class="form-control"
              @change="adicionarImagens"
            />
          </div>
          <div
            style="display: flex; margin-right: 10rem"
            class="col-md-2"
            v-for="(imagem, index) in state.imagens"
            :key="index"
          >
            <img :src="imagem.imagem" class="imagem" />
            <button @click="removerImagem(index)" class="btn_deletar_imagem">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                fill="currentColor"
                class="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path
                  d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="div-btn">
          <button
            class="btn btn_salvar float-end"
            id="submit-button"
            type="button"
            @click="salvarNegocio()"
          >
            Cadastrar
          </button>
          <button
            class="btn btn_voltar btn-secondary float-end me-3"
            id="voltar-button"
            type="submit"
            @click="router.push({ name: 'Negocio' })"
          >
            Voltar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";

export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      id: "",
      nome: "",
      status: "",
      categoria_anuncio_id: "",
      email: "",
      titulo: "",
      subtitulo: "",
      preco: "",
      descricao: "",
      telefone: "",
      estado_id: "",
      cidade_id: "",
      imagens: [],
      imagens_deletar: [],
    });
    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetchNegocio();
      }
      fetchGrupo();
      fetchEstado();
    });

    async function fetchNegocio() {
      try {
        const { data } = await services.negocio.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.id = data.id;
        state.nome = data.nome_anunciante;
        state.email = data.email;
        state.categoria_anuncio_id = data.categoria_anuncio_id;
        state.titulo = data.titulo;
        state.status = data.status;
        state.subtitulo = data.subtitulo;
        state.preco = data.preco;
        state.descricao = data.descricao;
        state.telefone = data.telefone;
        state.estado_id = data.estado_id;
        await fetchCidade(data.estado_id);
        state.cidade_id = data.cidade_id;
        state.imagens = data.imagens;
      } catch (error) {
        console.log(error);
      }
    }
    async function salvarNegocio() {
      try {
        let dados = new FormData();
        dados.append("nome_anunciante", state.nome);
        dados.append("status", state.status);
        dados.append("categoria_anuncio_id", state.categoria_anuncio_id);
        dados.append("email", state.email);
        dados.append("titulo", state.titulo);
        dados.append("subtitulo", state.subtitulo);
        dados.append("telefone", state.telefone);
        dados.append("preco", state.preco);
        dados.append("descricao", state.descricao);
        dados.append("estado_id", state.estado_id);
        dados.append("cidade_id", state.cidade_id);
        if (!state.id) {
          if (
            state.imagens.file == null ||
            state.imagens.file == undefined ||
            state.imagens.file == []
          ) {
            alert("O campo IMAGEM é obrigatório!!!");
            return;
          }
          services.negocio
            .saveNegocio({ token, dados })
            .then((data_anuncio) => {
              for (let i = 0; i < state.imagens.length; i++) {
                var formImagem = new FormData();
                formImagem.append("anuncio_id", data_anuncio.data.id);
                formImagem.append("imagem", state.imagens[i].file);
                services.negocio
                  .salvarImagem({ token, formImagem })
                  .then((data) => {
                    console.log(data);
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }
              router.push({ name: "Negocio" });
            });
        } else {
          if (state.imagens_deletar.length > 0) {
            try {
              const { data } = await services.negocio.deletarImagens({
                imagens: state.imagens_deletar,
                token,
              });
              console.log(data);
            } catch (error) {
              console.log(error);
            }
          }
          dados.id = state.id;
          dados.append("_method", "PATCH");
          services.negocio.update({ token, dados }).then((data_anuncio) => {
            console.log(data_anuncio);
            /*  for (let i = 0; i < state.imagens.length; i++) {
              var formImagem = new FormData();
              formImagem.append("anuncio_id", data_anuncio.data.id);
              formImagem.append("imagem", state.imagens[i].file);
              services.negocio
                .salvarImagem({ token, formImagem })
                .then((data) => {
                  console.log(data);
                })
                .catch((error) => {
                  console.log(error);
                });
            }
            */
            router.push({ name: "Negocio" });
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchGrupo() {
      try {
        const { data } = await services.negocio.getCatNegocio({ token });
        state.grupos = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchEstado() {
      try {
        const { data } = await services.negocio.estado();
        state.estados = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchCidade(estado_id) {
      try {
        const { data } = await services.negocio.cidade(estado_id);
        state.cidades = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function adicionarImagens(event) {
      for (let index = 0; index < event.target.files.length; index++) {
        const element = event.target.files[index];
        var objImagem = new Object();
        objImagem.id = index + 1;
        objImagem.file = element;
        objImagem.imagem = URL.createObjectURL(element);
        state.imagens.push(objImagem);
      }
    }
    async function removerImagem(index_imagem) {
      //  console.log(state.imagens[index_imagem].id);
      if (state.imagens[index_imagem].id != undefined) {
        state.imagens_deletar.push(state.imagens[index_imagem].id);
      }
      state.imagens.splice(index_imagem, 1);
      document.querySelector('input[type="file"]').value = null;
    }
    return {
      adicionarImagens,
      salvarNegocio,
      removerImagem,
      router,
      state,
      fetchCidade,
    };
  },
};
</script> 

<style scoped>
label {
  font-size: 14pt;
  color: #000;
  margin-bottom: 0;
}
input {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
}
input:focus {
  border: solid 1px blue;
}
textarea {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
}
textarea:focus {
  border: solid 1px blue;
}
select {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
}
select:focus {
  border: solid 1px blue;
}
.btn_salvar {
  background: green;
  color: #fff;
  transform: none;
}
.btn_salvar:hover {
  color: #fff;
}

.card {
  min-height: 94.8vh;
}
.div-btn {
  margin-top: 1rem;
}
textarea {
  resize: none;
}
.btn_deletar_imagem {
  margin-top: 10px;
  width: 25px;
  height: 25px;
  margin-left: 3px;
  background: rgb(170, 0, 0);
  color: #fff;
  border: solid 1px rgb(170, 0, 0);
  border-radius: 5px;
  transition: 0.3s;
}
.btn_deletar_imagem:hover {
  background: rgb(228, 0, 0);
  color: #fff;
  border: solid 1px rgb(228, 0, 0);
}
.imagem {
  height: auto;
  width: 300px;
  margin-top: 10px;
  object-fit: cover;
}
.breadcrumb {
  background: #fff;
  margin-bottom: 0;
}
a {
  color: #000;
  font-family: "PoppinsMedium";
  transition: 0.2s;
}
a:hover {
  color: #93c01f;
}
</style>